import React, { useEffect, useState } from "react";
import { Mail, Loader2, CheckCircle2, Plug } from "lucide-react";
import api from "../lib/api";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { toast } from "sonner";

// Conectar la cuenta Gmail del negocio para enviar correos por la API (HTTPS).
export const GmailConnect = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/gmail/status").then((r) => setStatus(r.data)).catch(() => setStatus(null)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const connect = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/gmail/oauth-url?redirect_base=${encodeURIComponent(window.location.origin)}`);
      const w = window.open(r.data.url, "_blank");
      if (!w) toast.error("Permite las ventanas emergentes e intenta de nuevo");
      toast.info("Autoriza con selecgtm@gmail.com en la nueva pestaña, luego vuelve y actualiza.");
    } catch (e) {
      toast.error(e.response?.data?.detail || "No se pudo iniciar la conexión");
    } finally { setBusy(false); }
  };

  const disconnect = async () => {
    setBusy(true);
    try { await api.post("/gmail/disconnect"); toast.success("Gmail desconectado"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };

  if (loading) return null;

  return (
    <Card className="rounded-sm border shadow-none p-4 space-y-3" data-testid="gmail-connect-card">
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-muted-foreground">
        <Mail className="h-3.5 w-3.5" /> Envío de correos (API de Gmail)
      </div>
      {status?.connected ? (
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-2 text-sm">
            <CheckCircle2 className="h-5 w-5 text-green-600" />
            <span>Conectado como <strong data-testid="gmail-connected-email">{status.email || "cuenta Gmail"}</strong>. Los correos saldrán desde esta cuenta.</span>
          </div>
          <Button variant="outline" size="sm" className="rounded-sm" onClick={disconnect} disabled={busy} data-testid="gmail-disconnect-btn">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Desconectar"}
          </Button>
        </div>
      ) : status?.configured ? (
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">Conecta la cuenta <strong>selecgtm@gmail.com</strong> para enviar facturas y cotizaciones por correo (funciona en producción).</p>
          <div className="flex items-center gap-2">
            <Button size="sm" className="rounded-sm font-bold gap-2" onClick={connect} disabled={busy} data-testid="gmail-connect-btn">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Plug className="h-4 w-4" />} Conectar Gmail
            </Button>
            <Button variant="ghost" size="sm" className="rounded-sm" onClick={load} data-testid="gmail-refresh-btn">Ya conecté, actualizar</Button>
          </div>
        </div>
      ) : (
        <p className="text-sm text-red-600" data-testid="gmail-not-configured">Falta configurar las credenciales de Google (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET) en el servidor.</p>
      )}
    </Card>
  );
};

export default GmailConnect;
